import { render } from "./RepeatBlockComponent.vue?vue&type=template&id=19ba7f55&scoped=true"
import script from "./RepeatBlockComponent.vue?vue&type=script&lang=js"
export * from "./RepeatBlockComponent.vue?vue&type=script&lang=js"

import "./RepeatBlockComponent.vue?vue&type=style&index=0&id=19ba7f55&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19ba7f55"

export default script